import React from 'react'
import clsx from 'clsx'

import classes from './HelperText.module.scss'

type HelperTextProps = {
  color?: 'default' | 'error'
}

const HelperText: React.FC<HelperTextProps> = ({
  color = 'default',
  children,
}) => {
  return (
    <p
      className={clsx(classes.root, {
        [classes.colorError]: color === 'error',
      })}
    >
      {children}
    </p>
  )
}

export default HelperText
